import address from 'Store/Location/address'
import region from 'Store/Location/region'

const modules = {
  address,
  region,
}

export default {
  namespaced: true,
  modules,
}
